var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.71 22.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#3600cc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tick Blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3600cc",
    className: "cls-1",
    d: "M22.71,10.69V12c0,.08,0,.16,0,.24-.07.49-.11,1-.22,1.46a11,11,0,0,1-4.21,6.65A11,11,0,0,1,9,22.45a11,11,0,0,1-6.61-4.19,11,11,0,0,1-2.3-8A10.94,10.94,0,0,1,2.83,3.87,11.11,11.11,0,0,1,9.4.18C9.83.1,10.26.06,10.69,0H12l.17,0a10.75,10.75,0,0,1,5,1.56,11.18,11.18,0,0,1,5.38,7.8C22.61,9.83,22.65,10.26,22.71,10.69ZM9.62,13.27,8.34,12.09c-.63-.57-1.24-1.17-1.9-1.71A1.09,1.09,0,0,0,4.71,11a1.19,1.19,0,0,0,.41,1.22l3.67,3.34a1.15,1.15,0,0,0,1.75,0l7.05-7,.18-.2A1.14,1.14,0,0,0,16,6.83L9.77,13.06A2.37,2.37,0,0,0,9.62,13.27Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBlue);
export default __webpack_public_path__ + "static/media/TickBlue.9fd8f21be50f897ec792d3eabf2e969b.svg";
export { ForwardRef as ReactComponent };